import React from 'react';
import { Container, Header } from 'semantic-ui-react';
import Footer from './Footer';

const Kontakt = () => {
    return (
        <div>
            <Footer fixed='top' />
            <Container text style={{ marginTop: '9em', marginBottom: '2em' }}>
                <Header as='h1' style={{ fontSize: '3.125rem' }}>Kontakt</Header>
                <p style={{ fontSize: '1.25rem' }}>Hier erfahren Sie, wer diese WebApp entwickelt hat und wie Sie Kontakt zu uns aufnehmen können.</p>

                <h2>Anfragen an:</h2>
                <p style={{ fontSize: '1.25rem' }}>Fabian Kors<br />Landeshauptstadt München | IT-Referat | it@M InnovationLab<br />fabian.kors@muenchen.de</p>

                <h2>Über uns</h2>
                <p style={{ fontSize: '1.25rem' }}>Kindl Go entstand aus der Kooperation der Landeshauptstadt München mit dem gemeinnützigen Gründungszentrum UnternehmerTUM. Das Entwicklungsteam arbeitete im Rahmen des Programms 'Digital Product School' insgesamt drei Monate von September bis November 2020. Die Teammitglieder waren:
                <ul><li>Christopher Wisse (Software Engineer)</li><li>Jia-Fang Hsu (Interaction Designer)</li><li>Pranay Tiru (Software Engineer)</li><li>Raul Villafuerte (AI Engineer)</li><li>Fabian Kors (Product Manager)</li></ul></p>
                <h2>Zukunft des Projekts</h2>
                <p style={{ fontSize: '1.25rem' }}>Seit Projetkabschluss wird Kindl Go von Christopher und Fabian im das InnovationLab des IT-Referats der Landeshauptstadt betreut. Die Innovationsabteilung begleitet Produkte jedoch nur zeitweise. Daher sind wir auf der Suche nach einer langfristigen, fachlichen und finanziellen Product Ownership. Melden Sie sich gern und holen Sie sich das 'Kindl' in Ihr Portfolio!</p>

            </Container>
        </div>
    )
};

export default Kontakt;